__turbopack_context__.v({
  "brand": "grI6FG_brand",
  "campaignBrand": "grI6FG_campaignBrand",
  "campaignContainer": "grI6FG_campaignContainer",
  "campaignContent": "grI6FG_campaignContent",
  "campaignDescription": "grI6FG_campaignDescription",
  "campaignDialogue": "grI6FG_campaignDialogue",
  "campaignFeature": "grI6FG_campaignFeature",
  "campaignFeatures": "grI6FG_campaignFeatures",
  "campaignHeading": "grI6FG_campaignHeading",
  "campaignIntro": "grI6FG_campaignIntro",
  "campaignIntroCopy": "grI6FG_campaignIntroCopy",
  "campaignRpcBrand": "grI6FG_campaignRpcBrand",
  "container": "grI6FG_container",
  "content": "grI6FG_content",
  "copy": "grI6FG_copy",
  "dialogue": "grI6FG_dialogue",
  "featureDescription": "grI6FG_featureDescription",
  "featureIcon": "grI6FG_featureIcon",
  "featureTitle": "grI6FG_featureTitle",
  "heading": "grI6FG_heading",
  "intro": "grI6FG_intro",
  "offer": "grI6FG_offer",
  "partnerWordmark": "grI6FG_partnerWordmark",
  "signIn": "grI6FG_signIn",
  "signInLink": "grI6FG_signInLink",
  "span": "grI6FG_span",
  "subText": "grI6FG_subText",
  "subtext": "grI6FG_subtext",
  "support": "grI6FG_support",
  "supportLinks": "grI6FG_supportLinks",
});
